export default __webpack_public_path__ + "static/media/picture4.a93e073f.png";